import { Box, CircularProgress } from '@mui/material';
import { white } from '@styles/colors';

function SpinLoader({ height = '100vh' }: { height?: string }) {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height={height}
      textAlign="center"
      bgcolor={white}
      width="100%"
      borderRadius={8}
    >
      <CircularProgress color="success" />
    </Box>
  );
}

export default SpinLoader;
